import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { HomepageResponse } from './models/Homepage-response.model';
import { HomepageModel } from './models/Homepage.model';


@Injectable({
  providedIn: 'root',
})
export class HomePageService extends BaseGQLService<HomepageResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: HomepageModel,
        clientName: 'HomePageService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryHomepageContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


